export default "__VITE_ASSET__BZw0Hrh4__"